/* @flow */

import React from 'react';
// $FlowIgnore
// $FlowIgnore
import InternalLink from './InternalLink';
import type { ParamsLinkProps } from './types';
import withRouting from 'utils/withRouting';

function CloseDetailsLink({
  router, style, children
}: ParamsLinkProps): React.Element {
  let { pathname } = router.location;

  return (
    <InternalLink
      style={style}
      to={pathname}
      aria-label="close-details-link"
    >
      {children}
    </InternalLink>
  );
}


export default withRouting(CloseDetailsLink);
